// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Task State
// -------------------------------
export interface TaskState extends EntityState<any> {
  common?: any;
  taskGroupPersonalList: Array<any>;
  taskGroupPersonalDetails: any;
  taskGroupList: Array<any>;
  taskGroupDetails: any;
  taskGroupAllList: Array<any>;
  taskGroupPersonalAllList: Array<any>;
  taskGroupPersonalListAll:Array<any>;
}

// -------------------------------
//  Task Adapter
// -------------------------------
export const taskAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Task Initial State
// -------------------------------
export const initialState: TaskState = taskAdapter.getInitialState(
  {
  common: null,
  taskGroupPersonalList: [],
  taskGroupPersonalDetails: {},
  taskGroupList: [],
  taskGroupDetails: {},
  taskGroupAllList: [],
  taskGroupPersonalAllList: [],
  taskGroupPersonalListAll: [],
  },
);
